type FunnelEventName =
  | "search_submit"
  | "search_results_loaded"
  | "listing_card_click"
  | "reservation_form_open"
  | "reservation_attempt_without_pet"
  | "auth_redirect_started"
  | "auth_redirect_returned"
  | "checkout_start"
  | "checkout_validation_error"
  | "checkout_redirect_mp";

type FunnelEventPayload = Record<string, boolean | number | string | null | undefined>;

const AUTH_REDIRECT_KEY = "allepets:last_auth_redirect";

function cleanPayload(payload: FunnelEventPayload) {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined)
  );
}

export function trackFunnelEvent(name: FunnelEventName, payload: FunnelEventPayload = {}) {
  if (typeof window === "undefined") return;

  const event = {
    event: name,
    funnel_event: name,
    ...cleanPayload(payload),
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
  window.dispatchEvent(new CustomEvent("allepets:funnel-event", { detail: event }));
}

export function rememberAuthRedirect(payload: FunnelEventPayload = {}) {
  if (typeof window === "undefined") return;

  const event = cleanPayload(payload);
  try {
    window.sessionStorage.setItem(AUTH_REDIRECT_KEY, JSON.stringify(event));
  } catch {}

  trackFunnelEvent("auth_redirect_started", event);
}

export function trackAuthRedirectReturned(payload: FunnelEventPayload = {}) {
  if (typeof window === "undefined") return;

  try {
    const raw = window.sessionStorage.getItem(AUTH_REDIRECT_KEY);
    if (!raw) return;

    window.sessionStorage.removeItem(AUTH_REDIRECT_KEY);
    const redirectPayload = JSON.parse(raw) as FunnelEventPayload;
    trackFunnelEvent("auth_redirect_returned", {
      ...redirectPayload,
      ...cleanPayload(payload),
    });
  } catch {}
}

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

